import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  let locations = useDataValue({
    context: 'locations',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    let location = locations.find(item => item.id === value)
    change(next => {
      next.location_id = location.id
      next.location_uuid = location._id
    })
  }
}
